module.exports = __webpack_public_path__ + "img/top-bar.f51c85e5.png";